import { render, staticRenderFns } from "./fertilizer-list.html?vue&type=template&id=03131f5c&scoped=true&"
import script from "./fertilizer-list.js?vue&type=script&lang=js&"
export * from "./fertilizer-list.js?vue&type=script&lang=js&"
import style0 from "./FertilizerList.vue?vue&type=style&index=0&id=03131f5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03131f5c",
  null
  
)

component.options.__file = "FertilizerList.vue"
export default component.exports